import React from "react";
import { Link } from "react-router-dom";
import Card from "../../../componentes/contenedores/Card";
import Agenda from "../../../componentes/plantilla/Agenda";
import Page from "../../../componentes/plantilla/Page";

const InicioCliente = () => {

  const datos = {
    titulo: {
      titulo: "Página principal",
      url: "/app/clientes/",
      tituloUrl: "Menu Principal",
      nombreUrl: "Inicio ",
    },
  };

  return (
    <Page datos={datos}>
      <Card titulo="Acceso rápido">
        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
          <div className="col">
            <div className="card h-100 text-center shadow-sm card-hover-effect animate__animated animate__fadeInUp">
              <div className="card-body d-flex flex-column justify-content-between">
                <div>
                  <i className="fas fa-shopping-cart fa-3x mb-3 text-success" />
                  <h5 className="card-title">Catálogo de Productos</h5>
                  <p className="card-text text-muted">Explora y compra nuestros productos.</p>
                </div>
                <Link to="/app/clientes/productos" className="btn btn-success mt-3 w-100">
                  Ver Productos
                </Link>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100 text-center shadow-sm card-hover-effect animate__animated animate__fadeInUp animate__delay-1s">
              <div className="card-body d-flex flex-column justify-content-between">
                <div>
                  <i className="fas fa-box fa-3x mb-3 text-primary" />
                  <h5 className="card-title">Mis Pedidos</h5>
                  <p className="card-text text-muted">Revisa el estado de tus órdenes.</p>
                </div>
                <Link to="/app/clientes/pedidos/editar" className="btn btn-primary mt-3 w-100">
                  Ver Pedidos
                </Link>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100 text-center shadow-sm card-hover-effect animate__animated animate__fadeInUp animate__delay-2s">
              <div className="card-body d-flex flex-column justify-content-between">
                <div>
                  <i className="fas fa-user-circle fa-3x mb-3 text-info" />
                  <h5 className="card-title">Mi Perfil</h5>
                  <p className="card-text text-muted">Administra tu información personal.</p>
                </div>
                <Link to="/app/clientes/perfil" className="btn btn-info mt-3 w-100">
                  Editar Perfil
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Card>
      <Card titulo="Estadisticas de tus pedidos">
        <Agenda />
      </Card>
    </Page>
  );
}

export default InicioCliente;